<template>
  <v-container
    class=" driver-insight-view"
    align-center
    justify-center
    fill-height
  >
    <v-layout class="pa-0" v-if="enabled && !loading && !noData" column>
      <v-layout align-center justify-center class="top-row" wrap>
        <v-flex md5 sm12>
          <pie-chart
            style="max-width: 300px;margin: auto"
            v-if="!loading"
            :data="pieChartData"
            :options="{
              centerText: { label: chartLabel, score: 'Drivers' },
              legend: false,
              responsive: true,
              maintainAspectRatio: true,
              tooltips: {
                  callbacks: {
                      label: function(item, data) {
                          let base =
                            data.labels[item.index] + ': <b>' + data.datasets[item.datasetIndex].data[item.index] + '%</b>'

                          if (data.datasets[item.datasetIndex].counts)
                            base += '(' + data.datasets[item.datasetIndex].counts[item.index] + ')'
                          return base
                      }
                  }
              }
            }"
          ></pie-chart>
        </v-flex>
        <v-flex md7 sm12 class="pr-3 pl-3">
          <v-layout column>
            <v-flex
              class="mb-2 question-area"
              v-if="metricQuestions.length > 0"
            >
              <QuestionRenderer
                :question="metricQuestions[1].question"
                :placeholders="{
                  brand_name: $store.getters['user/currentCampaign'].brand_name
                }"
              ></QuestionRenderer>
            </v-flex>
            <v-flex class="table-area">
              <SummaryTable
                :headers="['Driver', 'Count', 'Percentage']"
                :rows="table"
              ></SummaryTable>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="driver-distribution" align-center justify-center>
        <v-flex>
          <div  style="" class="driver-distribution-header">
            Driver Distribution
          </div>
          <horizontal-bar-chart
            :style="{ height: chartData.labels.length * 50 + 'px' }"
            style="max-width: 700px;margin: auto"
            v-if="!loading"
            :data="chartData"
            :options="{
              centerText: null,
              legend: false,
              responsive: true,
              maintainAspectRatio: false,
              gridLines: false,
              scales: {
                xAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      color: 'rgba(0, 0, 0, 0)'
                    },
                    ticks: {
                      callback: function() {
                        return null
                      }
                    },
                    categoryPercentage: .5,
                    barPercentage: 1.0,
                    display: false,
                    barThicknes: 30,
                  }
                ],
                yAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      color: 'rgba(0, 0, 0, 0)',
                      display: false
                    },
                    
                    categoryPercentage: .6,
                    barPercentage: 1.0,
                    display: true,
                    ticks: {
                      fontColor: colors.theme.primaryLight4
                    }
                  }
                ]
              }
            }"
          ></horizontal-bar-chart>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    <NoResult v-if="!loading && noData"></NoResult>
    <div v-if="!loading && !enabled">Driver question is disabled</div>
  </v-container>
</template>

<script>
import each from 'lodash/each'
import routes from '@/route_names'
import PieChart from '@/components/insights/PieChart.js'
import SummaryTable from '@/components/insights/SummaryTable'

import HorizontalBarChart from '@/components/insights/HorizontalBarChart.js'
import constants from '@/constants'
import insightsApi from '@/api/insights'
import QuestionRenderer from '@/components/QuestionRenderer'
import NoResult from '@/components/insights/NoResult'
import filterMixins from '@/mixins/filter'
export default {
  name: 'DriverInsightView',
  mixins:[filterMixins],
  components: {
    QuestionRenderer,
    PieChart,
    HorizontalBarChart,
    SummaryTable,
    NoResult
  },
  data() {
    return {
      loading: true,
      enabled: true,
      metricType: null,
      chartLabel: null,
      pieChartData: {
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: [
              '#A4FBEA',
              '#38B8B9',
              '#A3D2FF',
              '#7E62E3',
              '#A794EE',
              '#FEB24C',
              '#FFCC54',
              '#37AA79',
              '#57C97D',
              '#B1FBA4',
              '#E247F1',
              '#EE607F',
              '#FFC5A7',
              '#F49F68',
              '#FFC67A'
            ],
            data: []
          }
        ]
      },
      chartData: {
        labels: [],
        // datasets: [
        //   {
        //     label: '',
        //     backgroundColor: [
        //       constants.colors.rated1,
        //       constants.colors.rated2,
        //       constants.colors.rated3,
        //       constants.colors.rated4,
        //       constants.colors.rated5
        //     ],
        //     data: []
        //   }
        // ]
        datasets: []
      },
      noData: false,
      insights: {},
      metricQuestions: [],
      table: [],
      colors: constants.colors
    }
  },

  created() {
    if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_NPS_DRIVERS
    ) {
      this.metricType = 'nps'
      this.chartLabel = 'NPS'
    } else if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_CSAT_DRIVERS
    ) {
      this.metricType = 'sat'
      this.chartLabel = 'CSAT'
    } else if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_CES_DRIVERS
    ) {
      this.metricType = 'es'
      this.chartLabel = 'CES'
    }
    
    const vm = this
    this.$store
      .dispatch('campaign/getQuestions', {
        campaignId: this.$router.currentRoute.params.campaignId,
        type: this.metricType.toUpperCase()
      })
      .then(function(data) {
        vm.metricQuestions = data.questions
        if(data.questions[1].enabled !== 'NONE')
          vm.getData()
        else{
          vm.enabled = false
          vm.loading = false
        }
      })
  },
  watch: {
    $route: function() {
      const vm = this
      if(!vm.enabled)
        return
      this.getData()
    }
  },
  methods: {
    getData() {
      const vm = this
      vm.loading = true
      insightsApi
        .getDriverInsight({
          campaignId: this.$router.currentRoute.params.campaignId,
          metricType: this.metricType,
          query: {
            from: this.$router.currentRoute.query.from,
            to: this.$router.currentRoute.query.to,
            ...this.getAttributeFilters()
          }
        })
        .then(function(res) {
          const results = res.data.results
          vm.insights = results
          if (results === 'NO_RESULT') {
            vm.noData = true
            vm.loading = false
            return
          } else {
            vm.noData = false
          }
          const datasets = {}
          let pichartValues = []
          let pichartCounts = []
          vm.chartData.labels = results.map(function(d) {
            each(d.metric_labels.reverse(), function(metric_label) {
              datasets[metric_label.label] = datasets[metric_label.label] || {
                label: metric_label['label'],
                data: [],
                counts: []
              }
              datasets[metric_label.label].data.push(metric_label.percent)
              
              datasets[metric_label.label].counts.push(metric_label.count)
            })
            pichartValues.push(d.percent)
            pichartCounts.push(d.count)
            return d.driver
          })

          vm.pieChartData.labels = vm.chartData.labels
          vm.pieChartData.datasets[0].data = pichartValues
          vm.pieChartData.datasets[0].counts = pichartCounts

          const tmpData = []
          each(datasets, function(value, key) {
            tmpData.push(value)
          })
          if (tmpData.length === 3) {
            tmpData[0].backgroundColor = constants.colors.rated5
            tmpData[1].backgroundColor = constants.colors.rated3
            tmpData[2].backgroundColor = constants.colors.rated1
          } else {
            tmpData[0].backgroundColor = constants.colors.rated5
            tmpData[1].backgroundColor = constants.colors.rated4
            tmpData[2].backgroundColor = constants.colors.rated3
            tmpData[3].backgroundColor = constants.colors.rated2
            tmpData[4].backgroundColor = constants.colors.rated1
          }

          // each(tmpData, function(d) {
          //
          // })

          vm.chartData.datasets = tmpData
          vm.buildTable(results)
          vm.loading = false
        })
    },
    buildTable: function(insights) {
      const vm = this
      const labels = insights.map(function(d, i) {
        d.label = d.driver
        d.color = vm.pieChartData.datasets[0].backgroundColor[i]
        return d
      })
      this.table = labels
    },
    chartJsAfterLabelCallback: function(item, data) {
      console.log(item, data)
      return (
        data.datasets[item.datasetIndex].label +
        ':' +
        item.value +
        '(' +
        data.datasets[item.datasetIndex].counts[item.index] +
        ')'
      )
    }
  }
}
</script>

<style lang="stylus">
.driver-insight-view {
    padding-top: 45px
    .question-area {
        color: $color-primary-light-5
        font-size 16px
        text-align left
    }
    .table-area {
        color: $color-primary-light-1
        font-size 16px
        .count, .percent {
            font-weight 500
        }
    }
    .driver-distribution {
      margin-top 30px
    }
    .driver-distribution-header {
        color $color-primary-light-5
        font-size 16px
        font-weight: 500
        margin-top 30px
        max-width: 700px;
        margin: auto;
        text-align: center;
    }
}
</style>
